import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import parseContent from '../../../lib/parseContent';

const Favorite = props => {
  const {
    ariaLabel,
    isLoggedIn,
    title,
    toggleFavorite,
    tool = {},
    handleClickTool
  } = props;

  if (!isLoggedIn) return null;

  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();
    toggleFavorite(tool);
    handleClickTool(tool.favorite ? 'unfavorite' : 'favorite')();
  };

  const aria = useMemo(() => {
    let aria;
    try {
      const { favorite = '', unfavorite = '' } = JSON.parse(ariaLabel);
      aria = tool.favorite ? unfavorite : favorite;
    } catch (e) {
      aria = `${tool.favorite ? 'un' : ''}favorite {{title}}`;
    }
    return parseContent(aria, { title });
  }, [ariaLabel, title]);

  return (
    <button
      className={'favorite-icon' + (tool.favorite ? ' faved' : '')}
      onClick={onClick}
      aria-label={aria}
    />
  );
};

Favorite.propTypes = {
  tool: PropTypes.object,
  toggleFavorite: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  handleClickTool: PropTypes.func
};

export default Favorite;
